import React from 'react';
import BaseModal from '../common/BaseModal';

const BulkEditModal = ({
  show,
  onClose,
  selectedProducts,
  manufacturers,
  measureUnits,
  bulkManufacturerChange,
  setBulkManufacturerChange,
  bulkUnitChange,
  setBulkUnitChange,
  bulkQuantityChange,
  setBulkQuantityChange,
  onApply,
  filteredProducts,
}) => {
  const handleClose = () => {
    onClose();
    setBulkManufacturerChange('');
    setBulkUnitChange('');
    setBulkQuantityChange('');
  };

  const hasChanges = bulkManufacturerChange || bulkUnitChange || bulkQuantityChange;

  const footerButtons = (
    <>
      <button onClick={handleClose}
        style={{ padding: '6px 12px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)' , fontSize: '12px', fontWeight: '500', cursor: 'pointer' }}>
        Anuluj
      </button>
      <button onClick={onApply} disabled={!hasChanges}
        style={{
          padding: '6px 12px',
          border: `1px solid ${!hasChanges ? 'var(--border)' : 'var(--purple)'}`,
          color: !hasChanges ? 'var(--text-muted)' : 'var(--purple)', fontSize: '12px', fontWeight: '500',
          opacity: !hasChanges ? 0.6 : 1
        }}>
        {'✓'} Zapisz zmiany
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={show}
      onClose={handleClose}
      title="Zbiorcza edycja"
      subtitle={`${selectedProducts.size} zaznaczonych produktów`}
      size="sm"
      headerIcon={'✏️'}
      headerStyle={{
        border: '1px solid var(--purple)',
        color: 'var(--purple)'
      }}
      footer={footerButtons}
    >
      {/* Producent */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.35rem', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          {'🏭'} Producent
        </label>
        <select style={{ width: '100%', padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          value={bulkManufacturerChange} onChange={(e) => setBulkManufacturerChange(e.target.value)}>
          <option value="">-- Nie zmieniaj --</option>
          {manufacturers.map((manufacturer) => (
            <option key={manufacturer.id} value={manufacturer.id}>{manufacturer.nazwa}</option>
          ))}
        </select>
        <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '0.25rem' }}>
          Pozostaw puste aby nie zmieniać producenta
        </div>
      </div>

      {/* Jednostka miary */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.35rem', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          {'📏'} Jednostka miary
        </label>
        <select style={{ width: '100%', padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          value={bulkUnitChange} onChange={(e) => setBulkUnitChange(e.target.value)}>
          <option value="">-- Nie zmieniaj --</option>
          {measureUnits.map((unit) => (
            <option key={unit.id} value={unit.nazwa}>{unit.nazwa} ({unit.skrot})</option>
          ))}
        </select>
        <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '0.25rem' }}>
          Pozostaw puste aby nie zmieniać jednostki
        </div>
      </div>

      {/* Ilość jednostek */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.35rem', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          {'🔢'} Ilość jednostek
        </label>
        <input type="number" min="1"
          style={{ width: '100%', padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', fontSize: '12px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' }}
          value={bulkQuantityChange} onChange={(e) => setBulkQuantityChange(e.target.value)}
          placeholder="np. 1 dla pojedynczej sztuki" />
        <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '0.25rem' }}>
          Wpisz ilość (np. 1 szt dla shakera). To nadpisze automatyczne wykrywanie z nazwy.
        </div>
      </div>

      {/* Lista zaznaczonych produktów */}
      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.35rem', fontSize: '12px', fontWeight: '600', color: 'var(--text-secondary)' }}>
          {'📦'} Zaznaczone produkty ({selectedProducts.size})
        </label>
        <div style={{
          maxHeight: '120px', overflowY: 'auto',
          border: '1px solid var(--border)', borderRadius: '4px',
          padding: '0.5rem', backgroundColor: 'var(--bg)', fontSize: '12px'
        }}>
          {filteredProducts
            .filter(p => selectedProducts.has(p.id))
            .slice(0, 15)
            .map(product => (
              <div key={product.id} style={{
                padding: '3px 0', borderBottom: '1px solid var(--border)', lineHeight: '1.3'
              }}>
                <span style={{ color: 'var(--purple)', fontWeight: '600' }}>{product.manufacturer || '-'}</span>
                <span style={{ color: 'var(--text-muted)' }}> {'·'} </span>
                <span>{product.nazwa?.substring(0, 40)}...</span>
              </div>
            ))}
          {selectedProducts.size > 15 && (
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', fontStyle: 'italic', paddingTop: '6px' }}>
              ... i {selectedProducts.size - 15} więcej produktów
            </div>
          )}
        </div>
      </div>

      {/* Ostrzeżenie */}
      <div style={{
        background: 'var(--warning-light)', border: '1px solid var(--warning)', borderRadius: '4px',
        padding: '0.5rem 0.75rem', fontSize: '11px', color: 'var(--warning)'
      }}>
        <strong>{'⚠️'} Uwaga:</strong> Operacja zmieni dane dla wszystkich zaznaczonych produktów.
      </div>
    </BaseModal>
  );
};

export default BulkEditModal;
